import type { QrPayment } from "../api/types";

/** How often the app asks the server how far a QR is. */
export const ASK_EVERY_MS = 2_000;

/** A QR nobody can pay any more: refused by the bank, expired or withdrawn. */
export function isOver(status: QrPayment["status"]): boolean {
  return status === "failed" || status === "expired" || status === "cancelled";
}

/** "1:45": what is left of the two minutes of a QR; "0:00" once they passed. */
export function timeLeft(expiresAt: string, now: number): string {
  const seconds = Math.max(0, Math.floor((Date.parse(expiresAt) - now) / 1000));
  return `${String(Math.floor(seconds / 60))}:${String(seconds % 60).padStart(2, "0")}`;
}
